import { useTracking, track } from 'lib/analytics'
import { HeartEyesConfettiIcon } from 'baby-ui/foundation/BabylistIcons/BabylistIcons'
import Slide, { Title } from '../../Slide/Slide'
import { NextButton } from '../../OnboardingButtons/OnboardingButtons'
import css from './adoption-affirmation.styles.scss'
import { urlWithChecklistParam } from 'utils'

export default ({ nextPath }) => {
  const tracker = useTracking()
  const url = urlWithChecklistParam(nextPath)

  return (
    <Slide>
      <div className={css.AdoptionAffirmation__headerContainer}>
        <HeartEyesConfettiIcon />
        <Title className={css.AdoptionAffirmation__title}>
          Congratulations! <br /> Adoption is an amazing journey.
        </Title>
      </div>
      <NextButton
        onClick={() => {
          tracker.trackEvent({
            event: track.onboardingQuestionAnswered,
            eventLocation:
              track.EventLocation.ONBOARDING_MINUS_ADOPTION_AFFIRMATION,
          })
        }}
        to={url}
      />
    </Slide>
  )
}
